var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('d-menu',{attrs:{"mode":"inline"}},[_c('d-menu-item',[_vm._v("\n      这是一个菜单项\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }